import React from 'react';
import _ from 'lodash';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { CLIENT_SETTINGS, CLIENT_ALLOWANCE_ITEMS } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_ALLOWANCE_ITEM_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME, editAllowanceItem } from 'src/reducers/clients/allowanceItems';
import { getItem, setItem, getItemErrors } from 'src/reducers/common/itemReducer';
import { arrayToCheckBoxObject } from 'src/utils/Utils';
import AllowanceItemEditingForm from './components/AllowanceItemEditingForm';
import { useTranslation } from 'react-i18next';

let NewAllowanceItemForm = reduxForm({
  form: CLIENT_ALLOWANCE_ITEM_FORM
})(AllowanceItemEditingForm);

const mapStateToProps = (state, ownProps) => ({
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: {
    ...getItem(REDUCER_NAME, state),
    payrollRulesGroups: ownProps.formatedPayrollGroup
  }
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(editAllowanceItem(data));
  }
});

NewAllowanceItemForm = connect(mapStateToProps, mapDispatchToProps)(NewAllowanceItemForm);

const NewClientAllowanceItem = ({ dispatch, values }) => {
  const { clientAllowanceItem, checkedOnPayrollRulesGroups, existsConfirmedPayrollRulesGroups } = values;
  dispatch(setItem(REDUCER_NAME, clientAllowanceItem));

  const formatedPayrollGroup = arrayToCheckBoxObject(checkedOnPayrollRulesGroups);
  const { t } = useTranslation();
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.ClientAllowanceItems.EditClientAllowanceItem.attendance_item_setting_edit')}</h1>
      </div>
      <div className="l-wrap-xs">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.ClientAllowanceItems.components.ClientAllowanceItemsComponent.attendance_items_setting_list')} path={CLIENT_ALLOWANCE_ITEMS} />
            <BreadCrumb.Item label={t('features.ClientAllowanceItems.EditClientAllowanceItem.attendance_item_setting_edit')} />
          </BreadCrumb>
        </div>
        <NewAllowanceItemForm
          formatedPayrollGroup={formatedPayrollGroup}
          existsConfirmedPayrollRulesGroups={existsConfirmedPayrollRulesGroups}
          orgUnitType={_.get(clientAllowanceItem, 'unitType')}
        />
      </div>
    </div>
  );
};

export default connect()(NewClientAllowanceItem);
